var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('button',{staticClass:"btn"},[_vm._v("Buy")])]):_c('div',[_c('h1',[_vm._v("Loading...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }